<template>
  <div
    :id="id"
    :class="['radio', { 'radio--active': selected }, getTheme]"
    tabindex="0"
    role="radio"
    @click="select"
    @keydown.enter.prevent="select"
  >
    <div class="radio__circle" />
    <div class="radio__text">
      {{ item.Text }}
    </div>
  </div>
</template>

<script>
import { computed, ref } from 'vue'
import emitter from 'tiny-emitter/instance'

export default {
  name: 'nt-form-radio',
  props: {
    id: String,
    item: {
      type: Object,
      required: true,
      validator(val) {
        return (
          Object.hasOwnProperty.call(val, 'Text')
          && Object.hasOwnProperty.call(val, 'Value')
        )
      },
    },
    theme: {
      type: String,
      default: 'default',
    },
  },
  setup(props) {
    const selected = ref(false)
    const getTheme = computed(() => {
      return `radio--${props.theme}`
    })
    emitter.on('selectRadio', (val) => {
      selected.value = val === props.item.Value
    })

    function select() {
      emitter.emit('onSelectFormRadio', props.item.Value)
    }

    return {
      getTheme,
      select,
      selected
    }
  }
}
</script>

<style lang="scss" scoped>
.radio {
  $container: &;
  display: flex;
  align-items: center;
  margin-bottom: 2px;

  &:hover {
    cursor: pointer;
  }

  &__circle {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    padding: 2px;
    margin-right: 14px;
    border-radius: 100%;
    border: 1px solid #ccc;
  }

  &__text {
    font-size: 1rem;
    line-height: 1rem;
    letter-spacing: -1px;
    color: #908782;
    // font-weight: bold;
    white-space: nowrap;
  }

  &--active {
    #{$container}__circle {
      &::before {
        content: "";
        width: 100%;
        height: 100%;
        border-radius: 100%;
        background: #23acd8;
      }
    }
  }
  &--small {
    #{$container}__circle {
      width: 16px;
      height: 16px;
    }

    #{$container}__text {
      font-size: 16px;
      line-height: 16px;
    }
  }
}
</style>
